import { DynamicIndexObjectType, ValidBusinessObject } from '@iotv/iotv-v3-types'
import { ITimestamp_TTL } from '../Interfaces/TimeRelated'
import { ModelCommon } from '../ModelCommon'
import { IAlertDetail } from './AlertTypes'
import type { AlertIncidentType } from './enums'
import { Severity } from './enums'

const typeName = 'AlertTrigger'

export interface IAlertTrigger<T> extends ITimestamp_TTL {
  severity?: Severity
  _initiator?: ValidBusinessObject
  _entityTriggeringAlert?: ValidBusinessObject
  alertTriggerType?: AlertIncidentType
  alertTriggerSubtype?: string
  alertDetail?: IAlertDetail<T>
  ttl: number | undefined
  timestamp: number | undefined
  _summary?: string | undefined
  name?: string
  app_id?: string
}

export class AlertTrigger<T> extends ModelCommon implements DynamicIndexObjectType, IAlertTrigger<T> {
  constructor({ ...ob }: IAlertTrigger<T> & Partial<ValidBusinessObject>) {
    super(ob.type || typeName, { ...ob })
  }

  dpk?: string
  dsk?: string
  _initiator?: ValidBusinessObject
  _entityTriggeringAlert?: ValidBusinessObject
  alertTriggerType?: AlertIncidentType
  alertTriggerSubtype?: string
  _alertDetail?: IAlertDetail<T>
  ttl: number | undefined
  timestamp: number | undefined
  _summary?: string
  app_id?: string

  get timestampOpen() {
    return this.timestamp ?? undefined
  }

  set timestampOpen(timestamp: number | undefined) {
    this.timestamp = timestamp
  }

  get alertDetail() {
    return this._alertDetail
  }

  set alertDetail(detail) {
    this._alertDetail = detail
  }

  get entityTriggeringAlert() {
    return this._entityTriggeringAlert
  }

  set entityTriggeringAlert(entity: ValidBusinessObject | undefined) {
    this._entityTriggeringAlert = entity
  }

  get entityTriggeringAlertName() {
    return this._entityTriggeringAlert?.name
  }

  set entityTriggeringAlertName(name: string) {
    if (this._entityTriggeringAlert) this._entityTriggeringAlert.name = name
  }

  get summary() {
    return this._summary
  }

  set summary(summary: string | undefined) {
    this._summary = summary
  }

  get initiator() {
    return this._initiator
  }

  set initiator(initiator: ValidBusinessObject | undefined) {
    this._initiator = initiator
  }

  get initiatorName() {
    return this._initiator?.name
  }

  set initiatorName(noThnanks: any) {}

  updateDynamicKeys() {
    this.dsk = `${this.status}:${this.incidentType}:${this.incidentEntity?.sk}`
    this.dpk = this.type
  }
}
